import React from "react";
import cn from "classnames";
import * as styles from "./styles.module.scss";

/** ============================================================================
 * @component
 * Shown above header to give users additionally navigation options and announcements.
 *
 * @typedef {{
 * 	 href: string,
 *   text: string,
 *   newWindow: boolean
 * }} Link
 *
 * @param 	{string}  	centerText			Text displayed in the center at all widths
 * @param 	{Link[]} 	  leftLinks  			Links displayed on the left at desktop width
 * @param 	{Link[]} 	  rightLinks  		Links displayed on the right at desktop width
 * @return	{node}
 */

const Banner = ({ centerText, leftLinks, rightLinks }) => (
  <div className={styles.container}>
    <div className={styles.leftLinks}>
      {leftLinks && (
        <ul>
          {leftLinks.map((link, i) => (
            <li key={i}>
              <a className="caption" href={link.href}>
                {link.text}
              </a>
            </li>
          ))}
        </ul>
      )}
    </div>
    <div className={cn(`b2`, styles.centerText)}>{centerText}</div>
    <div className={styles.rightLinks}>
      {rightLinks && (
        <ul>
          {rightLinks.map((link, i) => (
            <li key={i}>
              <a className="caption" href={link.href}>
                {link.text}
              </a>
            </li>
          ))}
        </ul>
      )}
    </div>
  </div>
);

export default Banner;
